import {
    mdiCardAccountDetails,
    mdiFormatSection,
    mdiFrequentlyAskedQuestions,
    mdiHeadLightbulb,
    mdiHome,
    mdiShieldLock,
    mdiVideo,
} from '@mdi/js';
import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import store from '@/store';

Vue.use(VueRouter);

const routes: RouteConfig[] = [
    {
        path: '/',
        name: 'Categories',
        component: () => import(/* webpackChunkName: "categories" */ '../views/Categories.vue'),
        meta: {
            requiresAuth: true,
            inNavigation: true,
            icon: mdiHome,
            position: 0,
            title: 'navigation.home',
        },
    },
    {
        path: '/category/:id',
        name: 'Category',
        component: () => import(/* webpackChunkName: "category" */ '../views/Category.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/videos',
        name: 'Videos',
        component: () => import(/* webpackChunkName: "videos" */ '../views/Videos.vue'),
        meta: {
            requiresAuth: true,
            inNavigation: true,
            icon: mdiVideo,
            position: 1,
            title: 'navigation.videos',
        },
    },
    {
        path: '/videos/:id',
        name: 'Video',
        component: () => import(/* webpackChunkName: "video" */ '../views/Video.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/projects',
        name: 'Projects',
        component: () => import(/* webpackChunkName: "projects" */ '../views/Projects.vue'),
        meta: {
            requiresAuth: true,
            inNavigation: true,
            icon: mdiHeadLightbulb,
            position: 2,
            title: 'navigation.projects',
        },
    },
    {
        path: '/projects/:id',
        name: 'Project',
        component: () => import(/* webpackChunkName: "project" */ '../views/Project.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/processing/:id',
        name: 'Processing',
        component: () => import(/* webpackChunkName: "processing" */ '../views/Processing.vue'),
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: '/faq',
        name: 'FAQ',
        component: () => import(/* webpackChunkName: "faq" */ '../views/FAQ.vue'),
        meta: {
            inNavigation: true,
            icon: mdiFrequentlyAskedQuestions,
            position: 3,
            title: 'navigation.faq',
        },
    },
    {
        path: '/imprint',
        name: 'Imprint',
        component: () => import(/* webpackChunkName: "static-page" */ '../views/StaticPage.vue'),
        props: {
            text: 'imprint',
        },
        meta: {
            inNavigation: true,
            position: 4,
            icon: mdiCardAccountDetails,
            title: 'navigation.imprint',
        },
    },
    {
        path: '/legal',
        name: 'Legal',
        component: () => import(/* webpackChunkName: "static-page" */ '../views/StaticPage.vue'),
        props: {
            text: 'legal',
        },
        meta: {
            inNavigation: true,
            position: 5,
            icon: mdiFormatSection,
            title: 'navigation.legal',
        },
    },
    {
        path: '/privacy',
        name: 'Privacy',
        component: () => import(/* webpackChunkName: "static-page" */ '../views/StaticPage.vue'),
        props: {
            text: 'privacy',
        },
        meta: {
            inNavigation: true,
            position: 6,
            icon: mdiShieldLock,
            title: 'navigation.privacy',
        },
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue'),
    },
    {
        path: '/code/:code',
        name: 'Code',
        component: () => import(/* webpackChunkName: "code" */ '../views/Code.vue'),
    },
    {
        path: '*',
        name: '404',
        component: () => import(/* webpackChunkName: "login" */ '../views/StaticPage.vue'),
        props: {
            text: 'page404',
        },
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: routes,
});

router.beforeEach((to, from, next) => {
    if (to.matched.some((route) => route.meta.requiresAuth) && !store.getters.isLoggedIn) {
        return next({
            path: '/login',
            query: {
                redirect: to.fullPath,
            },
        });
    }

    next();
});

export default router;
